import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Brands} from '@ox/typings';
import {AppConfigService} from '@ox/utils';
@Component({
  selector: 'webu-search-dealerships',
  templateUrl: './search-dealerships-webu.component.html'
})
export class SearchDealershipsWebuComponent implements OnInit {
  @Input() searchTerm: string;
  @Input() brands: Array<string> = [];
  @Input() activeVehicleMake: string;
  @Input() prop44?: string;
  @Input() prop53?: string;
  @Output() brandSelected = new EventEmitter();
  @Output() searchChanged = new EventEmitter();

  public language = window.gm.bml?.lang;
  public dealerSearchForm: FormGroup;
  public searchAttributes = this.appConfig.fieldAttributes.dealer.search;
  public currentBrand: Brands = window.gm.bml.brand;
  private fieldAttributes = this.appConfig.fieldAttributes;

  constructor (
    protected fb: FormBuilder,
    protected appConfig: AppConfigService
  ){
    this.dealerSearchForm = this.fb.group({
      brandSelectorInput: new FormControl('', [
        Validators.required
      ]),
      searchInput: new FormControl('', [
      Validators.maxLength(this.searchAttributes.maxlength),
      Validators.required
      ])
    });
  }

  ngOnInit(): void {
    this.setBrandsList();
  }

  setBrandsList() {
    if(this.activeVehicleMake) {
      this.dealerSearchForm.controls['brandSelectorInput'].setValue(this.appConfig.appSettings.getMake(this.activeVehicleMake));
    } else {
      for (const brand in this.brands) {
        if (this.brands[brand].toLowerCase() === this.currentBrand) {
          this.dealerSearchForm.controls['brandSelectorInput'].setValue(this.brands[brand]);
        }
      }
    }
  }

  search() {
    let input = this.dealerSearchForm.controls['searchInput'].value.replace(/,/g, '');
    const regex = this.fieldAttributes.address.postalCode.pattern;
    const isZip = regex.test(input.toUpperCase());
    if(isZip){
      input = input.replace(/ /g, '').toUpperCase();
    }
    const selectedBrand = this.dealerSearchForm.controls['brandSelectorInput'].value;
    if(input && selectedBrand){
      this.brandSelected.emit(selectedBrand);
      this.searchChanged.emit(input);
    }
  }

}
